import { render, staticRenderFns } from "./BatchImportCom.vue?vue&type=template&id=1ecdadd2&scoped=true"
import script from "./BatchImportCom.vue?vue&type=script&lang=js"
export * from "./BatchImportCom.vue?vue&type=script&lang=js"
import style0 from "./BatchImportCom.vue?vue&type=style&index=0&id=1ecdadd2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdadd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecdadd2')) {
      api.createRecord('1ecdadd2', component.options)
    } else {
      api.reload('1ecdadd2', component.options)
    }
    module.hot.accept("./BatchImportCom.vue?vue&type=template&id=1ecdadd2&scoped=true", function () {
      api.rerender('1ecdadd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base-com/select/components/BatchImportCom.vue"
export default component.exports